import { Routes } from '@angular/router';
import { v2On } from '../v2/ui-v2.guard';
import { UsersPage } from './users.page';

export const usersRoutes: Routes = [
  {
    path: 'users',
    component: UsersPage,
    children: [
      {
        path: 'list',
        canMatch: [v2On],
        loadComponent: () => import('../v2/pages/org/list-users-v2.page').then(m => m.ListUsersV2Page),
      },
      {
        path: 'list',
        loadComponent: () => import('./list-users/list-users.page').then(m => m.ListUsersPage),
      },
      {
        path: 'invite',
        canMatch: [v2On],
        loadComponent: () => import('../v2/pages/org/invite-user-v2.page').then(m => m.InviteUserV2Page),
      },
      {
        path: 'invite',
        loadComponent: () => import('./invite-user/invite-user.page').then(m => m.InviteUserPage),
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
    ],
  },
];
